import styles from './node-ghost.module.css';

interface NodeGhostProps {
  width: number;
  height: number;
  children?: React.ReactNode;
}

/**
 * Translucent preview shown when hovering an expand dot.
 * Purely decorative — not interactive. Click the dot to confirm the add.
 */
export function NodeGhost({ width, height, children }: NodeGhostProps) {
  return (
    <div
      data-testid="expand-ghost"
      aria-hidden="true"
      className={styles.ghost}
      style={{ '--ghost-w': `${width}px`, '--ghost-h': `${height}px` } as React.CSSProperties}
    >
      {children}
    </div>
  );
}
